import keyBy from "lodash.keyby";
import { createSelector } from "reselect";

import { type AppStore } from "../../../index";

export const getMeals = (state: AppStore) => state.mealsPlans.list;

export const getMealsPlanByKey = createSelector([getMeals], (meals) => keyBy(meals, "id"));
